import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import Grid from '@material-ui/core/Grid'

import GalleryCarouselStyle from './galleryCarouselStyle.jsx'

const GalleryCard = ({classes, item}) => {

    return (
        <div className={classes.sliderContent}>
            <Grid container direction='column' className={classes.sliderContentCard}>
                <Grid item className={classes.backgroundImage} style={{backgroundImage : `url(${item.full_image_url})`}}>
                </Grid>     
            </Grid>
        </div>    
    );
}

export default withStyles(GalleryCarouselStyle)(GalleryCard)